import { cloneDeep } from "lodash";
import { DOMAIN_RECEIVED, REMOVE_SELECTED_DOMAIN, SELECTED_BOT, SELECTED_DOMAIN, UPDATE_DOMAIN, REMOVE_BOT, SET_DOMAIN_STATE } from "../constants";
import { updateDataInStorage } from "../../services/storage/LocalStorage";

const initialState = {
    domains: [],
    selectedDomain: null,
    selectedDomainDetails: [],
    selectedBotId: null,
    selectedBotDetails: null,
    domainState: false,
    defaultHomePageBotId : null,
};

const domainReducer = (state = initialState, action) => {
    switch (action.type) {
        case DOMAIN_RECEIVED:
            return { ...state, domains: action.payload.domains };

        case REMOVE_SELECTED_DOMAIN:
            return { ...state, selectedDomain: null, selectedDomainDetails: [] };

        case UPDATE_DOMAIN: {
            const updatedDomain = cloneDeep(action.payload.selectedDomain);
            const updatedDomainDetails = cloneDeep(action.payload.selectedDomainDetails);

            updateDataInStorage("StoredDomain", updatedDomain);
            return { ...state, selectedDomain: updatedDomain, selectedDomainDetails: action.payload.selectedDomainDetails };
        };

        case SELECTED_DOMAIN: {
            const selectedDomain = action.payload.selectedDomain
            const selectedDomainDetails = action.payload.selectedDomainDetails
            const defaultHomePageBotId = action.payload.defaultHomePageBotId

            return { ...state, selectedDomain, selectedDomainDetails:selectedDomainDetails, defaultHomePageBotId };
        };
        
        case REMOVE_BOT: {
            const selectedBotId = null;
            const selectedBotDetail = null;
            return { ...state, selectedBotId: selectedBotId, selectedBotDetails: selectedBotDetail };
        };

        case SET_DOMAIN_STATE: {
            const domainState = action.payload.domainState;
            return { ...state, domainState };
        }

        case SELECTED_BOT: {
            const selectedBotId = action.payload.selectedBotId;
            const selectedBotDetails = action.payload.selectedBotDetails;
            return { ...state, selectedBotId, selectedBotDetails };
        };

        default:
            return state;
    };
};

export default domainReducer;
